import { LANGUAGE_CODE } from '@healthhub/react-ui';
import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  APPOINTMENT_MAKE_NEW_HSG_SCREENING_CONFIRM_PATH,
  APPOINTMENT_MAKE_NEW_HSG_SCREENING_SLOT_SELECTION_PATH,
  APPOINTMENT_MAKE_NEW_HSG_SCREENING_SUCCESS_PATH,
  APPOINTMENT_NON_HAS_REQUEST_FORM_PATH,
  APPOINTMENT_NON_HAS_SCREENING_REQUEST_FORM_PATH,
  HEALTHIERSG_APPOINTMENT_HAS_REQUEST_FORM_PATIENT_OTP_PATH,
  HEALTHIERSG_APPOINTMENT_HAS_REQUEST_FORM_PATIENT_PATH,
  HEALTHIERSG_APPOINTMENTS_BEFORE_CARE_PATH,
  HEALTHIERSG_APPOINTMENTS_BREAST_CANCER_REQUEST_FORM_PATH,
  HEALTHIERSG_APPOINTMENTS_COLORECTAL_CANCER_REQUEST_FORM_PATH,
  HEALTHIERSG_APPOINTMENTS_FORM_NAVIGATION_PATH,
  HEALTHIERSG_APPOINTMENTS_FORM_SUCCESS_PATH,
  HEALTHIERSG_APPOINTMENTS_LOCATION_SELECTION_PATH,
  HEALTHIERSG_RECORDS_SCREENING_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const ShFormNavigationPage = lazy(() => import('./pages/ShFormNavigationPage/ShFormNavigationPage'));
const ShScreeningFormSuccessPage = lazy(() => import('./pages/ShScreeningFormSuccessPage/ShScreeningFormSuccessPage'));

const HSGHasPatientProfileFormPage = lazy(
  () => import('./pages/HSGHasPatientProfileFormPage/HSGHasPatientProfileFormPage')
);
const HSGOtpRequestFormPage = lazy(() => import('./pages/HSGOtpRequestFormPage/HSGOtpRequestFormPage'));
const NonHasRequestFormPage = lazy(() => import('./pages/NonHasRequestFormPage/NonHasRequestFormPage'));
const HSGScreeningLocationSelectionPage = lazy(
  () => import('./pages/HSGScreeningLocationSelectionPage/HSGScreeningLocationSelectionPage')
);

const BreastCancerRequestFormPage = lazy(
  () => import('./pages/BreastCancerRequestFormPage/BreastCancerRequestFormPage')
);
const ColorectalCancerRequestFormPage = lazy(
  () => import('./pages/ColorectalCancerRequestFormPage/ColorectalCancerRequestFormPage')
);

const HsgBeforeCarePage = lazy(() => import('./pages/HsgBeforeCarePage/HsgBeforeCarePage'));
const HSGScreeningSlotSelectionPage = lazy(
  () => import('./pages/HSGScreeningSlotSelectionPage/HSGScreeningSlotSelectionPage')
);
const HSGScreeningNewSlotConfirmationPage = lazy(
  () => import('./pages/HSGScreeningNewSlotConfirmationPage/HSGScreeningNewSlotConfirmationPage')
);
const HSGScreeningMakeNewSuccessPage = lazy(
  () => import('./pages/HSGScreeningMakeNewSuccessPage/HSGScreeningMakeNewSuccessPage')
);

export const HSG_APPOINTMENTS_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: HEALTHIERSG_RECORDS_SCREENING_PATH,
    component: () => <HSGScreeningLocationSelectionPage />,
    displayTitle: () => 'Select Location',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_APPOINTMENTS_LOCATION_SELECTION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <ShFormNavigationPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_APPOINTMENTS_FORM_NAVIGATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    backUrl: HEALTHIERSG_RECORDS_SCREENING_PATH,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <BreastCancerRequestFormPage />,
    displayTitle: () => 'Breast Cancer (Mammogram) Screening Request Form',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_APPOINTMENTS_BREAST_CANCER_REQUEST_FORM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <ShScreeningFormSuccessPage />,
    displayTitle: () => 'Screening Request Form',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_APPOINTMENTS_FORM_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    backUrl: HEALTHIERSG_RECORDS_SCREENING_PATH,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <ColorectalCancerRequestFormPage />,
    displayTitle: () => 'Colorectal Cancer Screening Request Form',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_APPOINTMENTS_COLORECTAL_CANCER_REQUEST_FORM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <HsgBeforeCarePage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_APPOINTMENTS_BEFORE_CARE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <HSGScreeningSlotSelectionPage />,
    backUrl: HEALTHIERSG_RECORDS_SCREENING_PATH,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_HSG_SCREENING_SLOT_SELECTION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <HSGScreeningNewSlotConfirmationPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_HSG_SCREENING_CONFIRM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: HEALTHIERSG_RECORDS_SCREENING_PATH,
    component: () => <HSGScreeningMakeNewSuccessPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_HSG_SCREENING_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <HSGOtpRequestFormPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_APPOINTMENT_HAS_REQUEST_FORM_PATIENT_OTP_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <HSGHasPatientProfileFormPage />,
    displayTitle: () => 'New Appointment',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_APPOINTMENT_HAS_REQUEST_FORM_PATIENT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <NonHasRequestFormPage />,
    displayTitle: () => 'Book Vaccination Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_NON_HAS_REQUEST_FORM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <NonHasRequestFormPage isFromScreenings />,
    displayTitle: () => 'Book Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_NON_HAS_SCREENING_REQUEST_FORM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
  },
];
